<template>
  <div class="slider-home cat-carousel" v-show="categorias && categorias.length > 0">
    <div class="d-flex align-items-center justify-content-between w-100">
      <h2 class="float-left">Categorias</h2>
      <div class="ver-todas-categorias">
        <a @click="$router.push('cursos/categoria/1')">VER TODAS</a>
      </div>
    </div>

    <carousel :dots="false" ref="carouselCategoriasHome">
      <carousel-item v-for="(categoria, index) in categorias"
                     :key="'categoria-' + categoria.id + '-' + index"
                     :titulo="categoria.categoria"
                     :imagem="categoria.imagem"
                     texto-url="ver categoria"
                     :url="`/cursos/categoria/${categoria.id}`"
                     :categoriaCarousel="true"/>
    </carousel>
  </div>
</template>

<script>
import CarouselItem from '@/core/components/CarouselItem'
import CategoriaAPI from '@/api/categorias-api'
import Carousel from '@/core/components/Carousel'
import ImageUtils from '@/core/utils/image-utils'

export default {
  name: 'CategoriasCarousel',
  components: { Carousel, CarouselItem },

  data () {
    return {
      categorias: []
    }
  },

  mounted () {
    CategoriaAPI.listarCategoriasHome().then(data => {
      let categorias = data

      this.categorias = categorias.map(categoria => {
        let imagem = ImageUtils.obterUrlCompletaImagem(categoria.imagem, 'categorias-app/')
        categoria.imagem = imagem
        return categoria
      })

      this.$refs.carouselCategoriasHome.applyOwlCarousel()
    })
  }
}
</script>

<style scoped>

</style>
